import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Toolbar,
  Divider,
  Button,
  List,
  ListItem,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Autocomplete,
  Checkbox,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../user-redux/selector";
import { appSelector } from "../../redux/selector";
import {
  assignCandidateToRecruiterAction,
  getActiveCandidatesAction,
  getAssignedCandidatesAction,
  getMyRecruitersAction,
  resetCandidatesAction,
  selectedRecruiterAction,
} from "../../redux/action";
import AdminRecruitersList from "./AdminRecruitersList";
import AllocatedCandidatesList from "./AllocatedCandidatesList";

// Sample data for recruiters and candidates
const recruiters = [
  { id: 1, name: "Rasamalla Shravan", role: "UI Developer" },
  { id: 2, name: "John Doe", role: "Frontend Developer" },
  { id: 3, name: "Jane Smith", role: "Backend Developer" },
  { id: 4, name: "Emily White", role: "Data Analyst" },
];

const AdminAllocation = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const dispatch = useDispatch();
  const { user } = useSelector(userSelector);
  const { myRecruiters, activeCandidates } = useSelector(appSelector);
  const [selectedRecruiter, setSelectedRecruiter] = useState("");
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [allocations, setAllocations] = useState([]);
  const [activeRecruiterId, setActiveRecruiterId] = useState(null);
  const [selectedRecruiterId, setSelectedRecruiterId] = useState("");

  // New State Variables for Search Functionality
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleIconClick = () => {
    setIsSearchActive(!isSearchActive);
    setSearchTerm("");
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  // Open the allocation dialog
  const handleDialogOpen = async () => {
    setSelectedRecruiter("");
    setSelectedCandidates([]);
    setOpenDialog(true);

    await dispatch(resetCandidatesAction());
    await dispatch(getActiveCandidatesAction(user?.id, 1, 200));
  };

  // Close the allocation dialog
  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  const handleChange = async (value) => {
    const selectedName = value;
    const selectedRecruiter = myRecruiters?.find(
      (recruiter) => recruiter?.recruiter_name === selectedName
    );
    await setSelectedRecruiter(selectedName);
    await setSelectedRecruiterId(selectedRecruiter?.recruiter_uid);
  };

  const handleSubmit = async () => {
    const allocatedCandidatesData = {
      candidate_ids: selectedCandidates,
      user_id: user?.id,
      recruiter_id: selectedRecruiterId,
    };
    await dispatch(
      assignCandidateToRecruiterAction(allocatedCandidatesData, user?.id)
    );
    setOpenDialog(false);
  };

  // Get the candidates assigned to the active recruiter
  const getCandidatesForRecruiter = (recruiterId) => {
    const allocation = allocations.find((a) => a.recruiter.uid === recruiterId);
    return allocation ? allocation.candidates : [];
  };

  // Get recruiters who have allocations
  const getAllocatedRecruiters = () => {
    const allocatedRecruiterIds = allocations.map((a) => a.recruiter.uid);
    return recruiters.filter((r) => allocatedRecruiterIds.includes(r.uid));
  };

  // Filter recruiters based on search term
  const filteredRecruiters = myRecruiters?.filter((recruiter) =>
    recruiter.recruiter_name.toLowerCase().startsWith(searchTerm.toLowerCase())
  );

  // Check if there are any allocations
  const hasAllocations = allocations.length > 0;

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      let rec_data = {
        company_id: user?.companyid,
      };
      dispatch(getMyRecruitersAction(rec_data));
    }
  }, []);

  useEffect(() => {
    if (selectedRecruiter?.recruiter_uid) {
      const recruiter_data = {
        recruiter_id: selectedRecruiter?.recruiter_uid,
      };
      dispatch(getAssignedCandidatesAction(recruiter_data));
    }
  }, [selectedRecruiter]);

  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "5px" }}>
        {/* <Grid item xs={12}>
          <Paper elevation={2}>
            <Toolbar>
              <Button
                variant="contained"
                // endIcon={<ArrowDropDownIcon />}
                style={{ backgroundColor: "#406882" }}
                onClick={handleDialogOpen}
              >
                Allocation
              </Button>
            </Toolbar>
          </Paper>
        </Grid> */}

        {/* Recruiters Display Grid */}
        {hasAllocations ? (
          <Grid item xs={2.4}>
            <Paper
              elevation={2}
              style={{
                height: "96vh",
                overflow: "scroll",
                borderRadius: "8px",
              }}
            >
              <Box>
                <Toolbar
                  sx={{
                    minHeight: "48px !important",
                    position: "sticky",
                    top: 0,
                    zIndex: 3,
                    bgcolor: "#fff",
                  }}
                >
                  <Typography>Recruiters</Typography>
                </Toolbar>
                <Divider />
              </Box>
              <Box>
                <List>
                  {getAllocatedRecruiters().map((recruiter) => (
                    <ListItem
                      key={recruiter.id}
                      button
                      onClick={() => setActiveRecruiterId(recruiter.id)}
                      selected={
                        selectedRecruiter?.recruiter_uid ===
                        recruiter.recruiter_uid
                      }
                    >
                      <Box display="flex" alignItems="center" gap={2}>
                        <Avatar />
                        <Box>
                          <Typography
                            variant="body1"
                            style={{ fontSize: "12px", fontWeight: "600" }}
                          >
                            {recruiter.name}
                          </Typography>
                          <Typography
                            variant="body2"
                            style={{ fontSize: "11px" }}
                          >
                            {recruiter.role}
                          </Typography>
                        </Box>
                      </Box>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Paper>
          </Grid>
        ) : (
          <Grid item xs={2.4}>
            <Paper elevation={2} style={{ height: "96vh" }}>
              <Box>
                <Toolbar
                  sx={{
                    minHeight: "48px !important",
                    position: "sticky",
                    top: 0,
                    zIndex: 3,
                    bgcolor: "#fff",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  {isSearchActive ? (
                    <TextField
                      value={searchTerm}
                      onChange={handleSearchChange}
                      placeholder="Search recruiter name"
                      variant="outlined"
                      size="small"
                      style={{ flex: 1 }}
                    />
                  ) : (
                    <Typography variant="body1">Recruiters</Typography>
                  )}
                  {isSearchActive ? (
                    <CloseIcon
                      onClick={handleIconClick}
                      style={{
                        cursor: "pointer",
                        marginLeft: "10px",
                        color: "#696969",
                      }}
                    />
                  ) : (
                    <SearchIcon
                      onClick={handleIconClick}
                      style={{
                        cursor: "pointer",
                        marginLeft: "10px",
                        color: "#696969",
                      }}
                    />
                  )}
                </Toolbar>
                <Divider />
              </Box>
              <AdminRecruitersList
                searchTerm={searchTerm}
                onSearchChange={handleSearchChange}
              />
            </Paper>
          </Grid>
        )}

        {/* Candidates Display Grid */}
        <Grid item xs={2.4}>
          <Paper elevation={2} style={{ height: "96vh" }}>
            <Box>
              <Toolbar
                sx={{
                  minHeight: "48px !important",
                  position: "sticky",
                  top: 0,
                  zIndex: 3,
                  bgcolor: "#fff",
                }}
              >
                <Typography>Candidates</Typography>
              </Toolbar>
              <Divider />
            </Box>
            <AllocatedCandidatesList />
          </Paper>
        </Grid>
      </Grid>

      {/* Dialog for Selecting Recruiters and Candidates */}
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "20px",
            height: "450px",
          },
        }}
      >
        <DialogTitle
          sx={{ textAlign: "left", fontWeight: "bold", color: "#406882" }}
        >
          Allocate Candidates To Recruiter
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
            {/* Recruiter Dropdown */}
            {/* <FormControl fullWidth sx={{ mb: 3 }}>
              <InputLabel>Select Recruiter</InputLabel>
              <Select
                labelId="recruiter-select-label"
                value={selectedRecruiter}
                onChange={(e) => {
                  handleChange(e.target.value);
                }}
                label="Recruiter"
              >
                {myRecruiters?.length > 0 &&
                  myRecruiters.map((recruiter) => (
                    <MenuItem
                      key={recruiter.id}
                      value={recruiter.recruiter_name}
                      sx={{ textTransform: "capitalize" }}
                    >
                      {recruiter.recruiter_name} - {recruiter.role}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl> */}

            {/* Candidates Autocomplete with Multi-select */}
            <Autocomplete
              multiple
              options={activeCandidates}
              disableCloseOnSelect
              getOptionLabel={(option) =>
                `${option.candidate_name} - ${option.role}`
              }
              renderOption={(props, option, { selected }) => (
                // <li {...props}>
                //   <Checkbox checked={selected} style={{ marginRight: 8 }} />
                //   <Box display="flex" alignItems="center" gap={1}>
                //     <Avatar />
                //     <span>{option.candidate_name}</span> -{" "}
                //     <small>{option.role}</small>
                //   </Box>
                // </li>
                <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
                  <Checkbox
                    checked={selected}
                    style={{ marginRight: 8, fontSize: "12px" }}
                  />
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                    gap={1}
                  >
                    <Typography
                      variant="body1"
                      component="span"
                      style={{ fontSize: "14px" }}
                    >
                      {option.candidate_name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      component="span"
                      style={{ fontSize: "12px" }}
                    >
                      {option.role}
                    </Typography>
                  </Box>
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Candidates" />
              )}
              value={
                activeCandidates?.length > 0 &&
                activeCandidates?.filter((c) =>
                  selectedCandidates?.includes(c.candidate_id)
                )
              }
              onChange={(event, newValue) => {
                setSelectedCandidates(
                  newValue.map((candidate) => candidate.candidate_id)
                );
              }}
              sx={{
                mb: 3,
                "& .MuiAutocomplete-inputRoot": {
                  "& .MuiAutocomplete-endAdornment": {
                    top: "unset",
                  },
                },
              }}
              ChipProps={{
                sx: {
                  ".MuiChip-root": {
                    fontSize: "0.875rem",
                    borderRadius: "8px",
                    margin: "2px",
                  },
                },
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AdminAllocation;
